import { Card, Divider, Icon } from "@mui/material";
import ConfirmationModal from "components/ConfirmationModal";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Pagination from "components/Pagination";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import Table from "components/Tables/Table";
import Loader from "components/loader";
import DashboardLayout from "layouts/DashboardLayout";
import { useEffect, useState } from "react";
import jobCategoryListing from "./components/jobCategoryListing";
import { useSnackbar } from "notistack";
import { APP_CONSTANTS } from "App.constant";
import JobCategoryAddEdit from "./components/jobCategoryAddEdit";
import { useNavigate } from "react-router-dom";

function JobCategoryPage() {
    const defaultCategoryObject = {
        'name': '',
        'parent_id': 0,
        'status': 1
    }
    const [deleteModel, setDeleteModel] = useState(false);
    const [currentCategoryData, setCurrentCategoryData] = useState(defaultCategoryObject);
    const [addEditSection, setAddEditSection] = useState(false);
    const [allCategories, setAllCategories] = useState([]);
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [isUpdateData, setIsUpdateData] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem('isLoggedIn') === null || localStorage.getItem('isLoggedIn').toString() === 'false') {
            navigate('/', { replace: true });
        }
        getJobCategoriesData(page);
    }, []);

    const handleEditItem = (data) => {
        setCurrentCategoryData(data);
        setIsUpdateData(true);
        setAddEditSection(true);
    };
    const handleDeleteItem = (data) => {
        setCurrentCategoryData(data);
        setDeleteModel(true);
    };
    const handleDiscardData = () => {
        setIsUpdateData(false);
        setAddEditSection(false);
    };

    const getJobCategoriesData = (pageNumber) => {
        setIsLoading(true);
        const token = "Bearer " + JSON.parse(localStorage.getItem('userData'))['token'];
        fetch(process.env.REACT_APP_API_URL + 'job-categories/summary?page=' + pageNumber, {
            method: 'GET',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": token
            }
        })
            .then(response => response.json())
            .then((responseData) => {
                if (responseData.statusCode === 200) {
                    responseData = responseData.data;
                    const finalCategoryData = jobCategoryListing(responseData.categories, handleEditItem, handleDeleteItem, addEditJobCategory, setCurrentCategoryData);
                    setAllCategories(responseData.categories);
                    setColumns(finalCategoryData.columns);
                    setRows(finalCategoryData.rows);
                    setTotalCount(responseData.totalCount);
                    setTotalPages(Math.ceil(responseData.totalCount / 10));
                }
                setIsLoading(false);
            })
            .catch(function (error) {
                setIsLoading(false);
            });
    };
    const deleteJobCategory = (categoryId) => {
        setIsLoading(true);
        const token = "Bearer " + JSON.parse(localStorage.getItem('userData'))['token'];
        fetch(process.env.REACT_APP_API_URL + 'job-categories/delete-job-category?id=' + categoryId, {
            method: 'DELETE',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": token
            }
        })
            .then(response => response.json())
            .then((data) => {
                setCurrentCategoryData(defaultCategoryObject);
                const showMessage = data.message;
                let messageVariant = 'error';
                if (data.statusCode === 200) {
                    setDeleteModel(false);
                    getJobCategoriesData(1);
                    messageVariant = 'success';
                }
                enqueueSnackbar(APP_CONSTANTS.JOB_CATEGORY[showMessage], { variant: messageVariant });
                setIsLoading(false);
            })
            .catch(function (error) {
                setIsLoading(false);
            });
    };
    const addEditJobCategory = (saveUpdateCategoryData = {}) => {
        setIsLoading(true);
        const token = "Bearer " + JSON.parse(localStorage.getItem('userData'))['token'];
        let url = process.env.REACT_APP_API_URL + 'job-categories/save-job-category';
        let method = "POST";
        if (saveUpdateCategoryData.id !== undefined) {
            url = process.env.REACT_APP_API_URL + 'job-categories/update-job-category';
        }
        fetch(url, {
            method: method,
            body: JSON.stringify(saveUpdateCategoryData),
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": token
            }
        })
            .then(response => response.json())
            .then((data) => {
                setCurrentCategoryData(defaultCategoryObject);
                const showMessage = data.message;
                let messageVariant = 'error';
                if (data.statusCode === 200) {
                    setIsUpdateData(false);
                    setAddEditSection(false);
                    getJobCategoriesData(1);
                    messageVariant = 'success';
                }
                setIsLoading(false);
                enqueueSnackbar(APP_CONSTANTS.JOB_CATEGORY[showMessage], { variant: messageVariant });
            })
            .catch((error) => {
                setIsLoading(false);
            });
    };

    return <>
        <DashboardLayout>
            <DashboardNavbar />
            <ConfirmationModal
                show={deleteModel}
                headerTitle={'Delete Category'}
                bodyText={'Do you want to delete category?'}
                closeAction={{
                    color: 'info',
                    title: 'Cancel',
                }}
                confirmAction={{
                    color: 'error',
                    title: 'Confirm',
                }}
                handleClose={() => {
                    setDeleteModel(false);
                    setCurrentCategoryData(defaultCategoryObject);
                }}
                handleConfirm={() => {
                    setDeleteModel(false);
                    deleteJobCategory(currentCategoryData.id);
                }} />
            <SoftBox py={3}>
                <SoftBox mb={3}>
                    <Card>
                        <SoftBox display="flex" justifyContent="space-between" alignItems="center" alignSelf="flex-end" style={{
                            "margin": "16px 16px 0 16px"
                        }}>
                            {
                                !addEditSection ? <>
                                    <SoftButton variant="gradient" color="dark" onClick={() => setAddEditSection(true)}>
                                        <Icon fontSize="default" color="inherit">
                                            add
                                        </Icon>&nbsp;&nbsp;Add Job Category
                                    </SoftButton>
                                </> : <>
                                    <SoftButton variant="gradient" color="error" onClick={handleDiscardData}>
                                        <Icon fontSize="default" color="inherit">
                                            close
                                        </Icon>&nbsp;&nbsp; Discard
                                    </SoftButton>
                                    &nbsp;&nbsp;
                                    <SoftButton variant="gradient" color="success" onClick={() => addEditJobCategory(currentCategoryData)}>
                                        <Icon fontSize="default" color="inherit">
                                            check
                                        </Icon>&nbsp;&nbsp; {isUpdateData ? "Update" : "Save"}
                                    </SoftButton>
                                </>
                            }
                        </SoftBox>
                        <Divider flexItem />
                        {
                            !addEditSection ? <>
                                {
                                    !isLoading ? <>
                                        <SoftBox
                                            sx={{
                                                "& .MuiTableRow-root:not(:last-child)": {
                                                    "& td": {
                                                        borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                                                            `${borderWidth[1]} solid ${borderColor}`,
                                                    },
                                                },
                                            }}
                                        >
                                            {
                                                totalCount > 0 ?
                                                    <Table
                                                        columns={columns}
                                                        rows={rows} /> :
                                                    <SoftBox display="flex" flexDirection="column" style={{
                                                        "alignItems": "center",
                                                        "margin": "0 16px 16px 16px"
                                                    }}>
                                                        <SoftTypography variant="button" fontWeight="medium">
                                                            No Data Found
                                                        </SoftTypography>
                                                    </SoftBox>
                                            }
                                        </SoftBox>
                                    </> : <>
                                        <Loader classes='black' />
                                    </>
                                }
                                {
                                    !isLoading && totalCount > 0 && <>
                                        <Pagination
                                            maxPages={totalPages}
                                            currentPage={page}
                                            onPageChange={(pageNumber) => {
                                                setPage(pageNumber);
                                                getJobCategoriesData(pageNumber);
                                            }} />
                                    </>
                                }
                            </> : <>
                                <JobCategoryAddEdit
                                    currentCategoryData={currentCategoryData}
                                    allCategories={allCategories} />
                            </>
                        }
                        {
                            addEditSection && <>
                                <Divider flexItem />
                                <SoftBox display="flex" justifyContent="space-between" alignItems="center" alignSelf="flex-end" style={{
                                    "margin": "0 16px 16px 16px"
                                }}>
                                    <>
                                        <SoftButton variant="gradient" color="error" onClick={handleDiscardData}>
                                            <Icon fontSize="default" color="inherit">
                                                close
                                            </Icon>&nbsp;&nbsp; Discard
                                        </SoftButton>
                                        &nbsp;&nbsp;
                                        <SoftButton variant="gradient" color="success" onClick={() => addEditJobCategory(currentCategoryData)}>
                                            <Icon fontSize="default" color="inherit">
                                                check
                                            </Icon>&nbsp;&nbsp; {isUpdateData ? "Update" : "Save"}
                                        </SoftButton>
                                    </>
                                </SoftBox>
                            </>
                        }
                    </Card>
                </SoftBox>
            </SoftBox>
        </DashboardLayout>
    </>;
}

export default JobCategoryPage;